import { LegalLayout } from "../components/LegalLayout";
import { Seo } from "../components/Seo";

const H2 = ({ children }) => (
  <h2 className="font-heading text-2xl md:text-3xl font-bold uppercase tracking-tight text-white mt-12 mb-4">
    {children}
  </h2>
);

export default function CGU() {
  return (
    <>
      <Seo
        title="Conditions générales d'utilisation — PDR France"
        description="Conditions générales d'utilisation (CGU) du site pdrfrance.fr de PDR France."
        path="/cgu"
      />
      <LegalLayout
      title="Conditions générales d'utilisation"
      eyebrow="CGU · Conditions d'utilisation"
      lastUpdate="Décembre 2025"
    >
      <p>
        Les présentes Conditions Générales d'Utilisation (ci-après
        « CGU ») ont pour objet de définir les modalités et conditions
        d'utilisation du site pdrfrance.fr (ci-après « le Site »),
        édité par PDR FRANCE.
      </p>

      <H2>Article 1 — Acceptation des CGU</H2>
      <p>
        L'accès et l'utilisation du Site impliquent l'acceptation pleine
        et entière des présentes CGU. Si vous n'acceptez pas ces
        conditions, merci de ne pas utiliser le Site.
      </p>

      <H2>Article 2 — Accès au Site</H2>
      <p>
        Le Site est accessible gratuitement à tout utilisateur disposant
        d'un accès internet. Tous les coûts liés à l'accès au Site
        (matériel, logiciels, connexion) sont à la charge exclusive de
        l'utilisateur.
      </p>
      <p>
        PDR FRANCE se réserve le droit, sans préavis ni indemnité, de
        fermer temporairement ou définitivement le Site ou l'accès à
        un ou plusieurs services pour effectuer des opérations de
        maintenance, d'amélioration ou pour toute autre raison.
      </p>

      <H2>Article 3 — Services proposés</H2>
      <p>
        Le Site a pour objet de présenter les services de débosselage
        sans peinture, smart repair, gestion de sinistres grêle et
        autres prestations automobiles proposés par PDR FRANCE, ainsi
        que de permettre aux utilisateurs de demander un devis ou de
        prendre contact.
      </p>

      <H2>Article 4 — Obligations de l'utilisateur</H2>
      <p>L'utilisateur s'engage à :</p>
      <ul className="list-disc list-inside space-y-1 text-white/75">
        <li>Ne pas utiliser le Site à des fins illégales ou contraires aux CGU</li>
        <li>Fournir des informations exactes lors de l'utilisation des formulaires</li>
        <li>Ne pas porter atteinte aux droits de propriété intellectuelle</li>
        <li>Ne pas tenter de perturber le fonctionnement du Site</li>
        <li>Ne pas extraire, copier ou reproduire le contenu sans autorisation</li>
      </ul>

      <H2>Article 5 — Propriété intellectuelle</H2>
      <p>
        L'ensemble des éléments du Site (textes, images, vidéos, logos,
        structure) sont la propriété exclusive de PDR FRANCE et sont
        protégés par les lois françaises et internationales relatives à
        la propriété intellectuelle. Toute reproduction non autorisée
        est interdite.
      </p>

      <H2>Article 6 — Protection des données personnelles</H2>
      <p>
        Le traitement des données personnelles collectées via le Site
        est détaillé dans notre{" "}
        <a href="/confidentialite" className="text-[#007AFF] hover:underline">
          Politique de confidentialité
        </a>
        .
      </p>

      <H2>Article 7 — Cookies</H2>
      <p>
        Le Site utilise des cookies dans les conditions détaillées dans
        notre{" "}
        <a href="/cookies" className="text-[#007AFF] hover:underline">
          Politique de cookies
        </a>
        .
      </p>

      <H2>Article 8 — Responsabilité</H2>
      <p>
        PDR FRANCE s'efforce d'assurer au mieux de ses possibilités
        l'exactitude et la mise à jour des informations diffusées sur
        le Site. Toutefois, PDR FRANCE ne peut garantir l'exactitude,
        la précision, l'exhaustivité ou le caractère actuel des
        informations mises à disposition.
      </p>
      <p>
        PDR FRANCE ne pourra être tenue responsable des dommages directs
        ou indirects résultant de l'utilisation du Site.
      </p>

      <H2>Article 9 — Liens hypertextes</H2>
      <p>
        Le Site peut contenir des liens vers d'autres sites internet.
        PDR FRANCE n'exerce aucun contrôle sur ces sites tiers et
        décline toute responsabilité quant à leur contenu.
      </p>

      <H2>Article 10 — Modification des CGU</H2>
      <p>
        PDR FRANCE se réserve le droit de modifier les présentes CGU à
        tout moment. Les utilisateurs sont invités à les consulter
        régulièrement. Les modifications prendront effet dès leur
        publication sur le Site.
      </p>

      <H2>Article 11 — Droit applicable et juridiction compétente</H2>
      <p>
        Les présentes CGU sont soumises au droit français. Tout litige
        relatif à leur interprétation ou exécution relèvera de la
        compétence exclusive des tribunaux de Saint-Étienne, sauf
        disposition d'ordre public contraire.
      </p>

      <H2>Article 12 — Contact</H2>
      <p>
        Pour toute question relative aux présentes CGU, vous pouvez
        contacter PDR FRANCE à :{" "}
        <a href="mailto:debosselage@pdrfrance.fr" className="text-[#007AFF] hover:underline">
          debosselage@pdrfrance.fr
        </a>
      </p>
    </LegalLayout>
    </>
  );
}
